export { default } from './InlinePageSectionHeading';
export * from './InlinePageSectionHeading';
